// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadasLote_ListBulkOperationsInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /mensagens_programadas_lote/list_bulk_operations
 *
 * Optional pagination parameters for listing bulk messaging operations.
 */
import { registerContract } from './validate'

export interface MensagensProgramadasLote_ListBulkOperationsInput {
limit?: number
offset?: number
}

registerContract('MensagensProgramadasLote_ListBulkOperationsInput', {
  limit:  { type: 'number',  required: false },
  offset: { type: 'number',  required: false },
})
